export const BANNER_IMAGE =
  'https://pastatic.picsart.com/cms-pastatic/2e80e834-2bf4-4535-91c0-c7af92a26b38.png';
export const POST_LIMIT = 60;
export const INPUT_PLACEHOLDER = 'Search fonts';
export const FONTS_BUTTON_TEXT = 'Use this font';
export const LOAD_MORE_BUTTON = 'Load More';
export const DEFAULT_PATH = 'fonts';
